import React from 'react'
import { CLUB_URL_DOMAIN } from '../../../utils/env'
import { Grid } from 'antd-mobile-v5'
import styles from './BuyCards.module.css'

const ChangeEcardsDetail = () => {

  const memberCenterUrl = CLUB_URL_DOMAIN + '/pages-mine/mine/member-center'
  const couponList = [{
    brandName: "吉影",
    useRangeShow: "指定商品可用",
    useConditionShow: "满3000可用",
    money: "1600"
  }, {
    brandName: "影石Insta360",
    useRangeShow: "全部商品可用",
    useConditionShow: "满1500可用",
    money: "100"
  }, {
    brandName: "DIVEVOLK",
    useRangeShow: "全部商品可用",
    money: "9折",
    moneyType: "discount"
  }, {
    brandName: "同程白金会员",
    useRangeShow: "",
    useConditionShow: "免费会员",
    money: "90天",
    moneyType: "discount"
  }, {
    brandName: "亿点海外流量",
    useRangeShow: "",
    useConditionShow: "",
    money: "85折",
    moneyType: "discount"
  }, {
    brandName: "南北极船票",
    useRangeShow: "",
    useConditionShow: "",
    money: "1000",
  }]

  const toClubMemberPage = () => {
    window.location.href = memberCenterUrl
  }

  return <div className={styles.wrapper}>
    {/* 卡片畅换 */}
    <div className={styles['block-space']}>
      <div className={styles["block-title"]}>卡片畅换</div>
      <div className={styles["block-desc"]}>一年电子卡面随意换，不限证书数量，价值594元</div>
      <img
        src={require('../../../assets/images/club/card_img_banner.jpg')}
        className={styles["block-banner-img"]}
        onClick={toClubMemberPage} />
    </div>
    {/* 课程优惠 */}
    <div className={styles['block-space']}>
      <div className={styles["block-title"]}>线下课程优惠立减</div>
      <div className={styles["block-desc"]}>开通会员即可领取课程专属优惠券，总价值450元</div>
      <img
        src={require('../../../assets/images/club/course_coupon_banner.jpg')}
        className={styles["block-banner-img"]}
        onClick={toClubMemberPage} />
    </div>
    {/* 礼品福利多 */}
    <div className={styles["block-space"]}>
      <div className={styles["block-subscript-title"]}>
        <div className={styles["block-title"]}>礼品福利多</div>
        <div className={styles["block-tips"]}>会员专享</div>
      </div>
      <div className={styles["block-desc"]}>多种周边礼品随意选，价值158+元</div>
      <div className={styles["gear-bottom"]}>
        <div className={styles["goods"]}>
          <img src="https://club-img.padi.com.cn/file-img-goodsImg1/2025/0102/1735810172_67765c7cd46ea.png" className={styles["good-img"]} />
          <div className={styles["goods-name"]}>黑金帽+贴纸+徽章</div>
          <button className={styles["receive-btn"]} onClick={toClubMemberPage}>免费领取</button>
        </div>
        <div className={styles["goods"]}>
          <img src="https://club-img.padi.com.cn/file-img-goodsImg2/2025/0102/1735810185_67765c89103eb.jpg" className={styles["good-img"]} />
          <div className={styles["goods-name"]}>PADI LOGO黑色T恤</div>
          <button className={styles["receive-btn"]} onClick={toClubMemberPage}>免费领取</button>
        </div>
        <div className={styles["goods"]}>
          <img src="https://club-img.padi.com.cn/file-img-goodsImg3/2025/0102/1735810194_67765c922e921.png" className={styles["good-img"]} />
          <div className={styles["goods-name"]}>速干巾</div>
          <button className={styles["receive-btn"]} onClick={toClubMemberPage}>免费领取</button>
        </div>
      </div>
    </div>
    {/* 色彩还原 */}
    <div className={styles['block-space']}>
      <div className={styles["block-subscript-title"]}>
        <div className={styles["block-title"]}>色彩还原</div>
        <div className={styles["block-tips"]}>会员畅享</div>
      </div>
      <div className={styles["block-desc"]}>独家AI大模型水下照片还原色彩，无限批量还原，价值158元</div>
      <div className={styles["colorrcy-box"]}>
        <img
          src="https://club-img.padi.com.cn/file-img-img/2024/0418/1713406517_6620823542425.png"
          className={styles["block-banner-img"]} />
        <div className={styles["colorrcy-bottom"]}>
          <button className={styles["colorrcy-probation"]} onClick={toClubMemberPage}>非会员试用 5张/天</button>
          <button className={styles["colorrcy-open"]} onClick={toClubMemberPage}>开通会员畅用</button>
        </div>
      </div>
    </div>
    {/* 周边立省 */}
    <div className={styles["block-space"]}>
      <div className={styles["block-title"]}>周边立省</div>
      <div className={styles["gear-coupons-desc"]}>
        <div className={styles["block-desc"]}>T恤卫衣帽子随意选</div>
        <div className={styles.more} onClick={toClubMemberPage}>
          <text className={styles["more-text"]}>更多</text>
          <div className={styles["more-arrow"]}></div>
        </div>
      </div>
      <div className={styles["gear-coupons-bottom"]}>
        <div className={styles.goods}>
          <img src="https://club-img.padi.com.cn/file-img-goodsImg0/2025/0102/1735825559_67769897e068f.png" className={styles["good-img"]} />
          <text className={styles["goods-name"]}>卫衣</text>
          <div className={styles["receive-btn-wrap"]}>
            <button className={styles["receive-btn"]} onClick={toClubMemberPage}>立即购买</button>
            <div className={styles["discount-tag"]}>
              <img className={styles["discount-tag-bg"]}
                src="https://club-img.padi.com.cn/web/mine/discount-tag-bg.png" />
              <div className={styles["discount-text"]}>85折</div>
            </div>
          </div>
        </div>
        <div className={styles.goods}>
          <img src="https://club-img.padi.com.cn/file-img-goodsImg1/2025/0102/1735825572_677698a4e1326.jpg" className={styles["good-img"]} />
          <text className={styles["goods-name"]}>复古棒球帽</text>
          <div className={styles["receive-btn-wrap"]}>
            <button className={styles["receive-btn"]} onClick={toClubMemberPage}>立即购买</button>
            <div className={styles["discount-tag"]}>
              <img className={styles["discount-tag-bg"]}
                src="https://club-img.padi.com.cn/web/mine/discount-tag-bg.png" />
              <div className={styles["discount-text"]}>85折</div>
            </div>
          </div>
        </div>
        <div className={styles.goods}>
          <img src="https://club-img.padi.com.cn/file-img-goodsImg2/2025/0102/1735825581_677698ad1f055.jpg" className={styles["good-img"]} />
          <text className={styles["goods-name"]}>水母服</text>
          <div className={styles["receive-btn-wrap"]}>
            <button className={styles["receive-btn"]} onClick={toClubMemberPage}>立即购买</button>
            <div className={styles["discount-tag"]}>
              <img className={styles["discount-tag-bg"]}
                src="https://club-img.padi.com.cn/web/mine/discount-tag-bg.png" />
              <div className={styles["discount-text"]}>85折</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className={styles['block-space']}>
      <div className={styles['block-title']}>大牌合作</div>
      <div className={styles['block-desc']}>大牌折扣省好多，海外流量超值购，价值3000+元</div>
      <Grid columns={2} gap={7} className={styles['cooperation-list']}>
        {couponList.map(coupon => <Grid.Item>
          <div className={styles['coupon-item']}>
            <div className={styles['item-left']}>
              <div className={styles['price-group']}>
                <div className={styles['price-symbol']}>￥</div>
                <div className={styles['price']}>{ coupon.money }</div>
              </div>
              <div className={styles['"condition']}>{ coupon.useConditionShow || '' }</div>
            </div>
            <div className={styles['item-center']}></div>
            <div className={styles['item-right']}>
              <div className={styles['range']}>{ coupon.brandName }</div>
              <div className={styles['btn']} onClick={toClubMemberPage}>立即领取</div>
            </div>
          </div>
        </Grid.Item>)}
      </Grid>
    </div>
  </div >
}

export default ChangeEcardsDetail